import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ButtonImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/buttonImpression.trackingInfo";
import { getJsonPayload } from "@omni/utils/dom.utils";

import { findClosestContext } from "../../trackers/utils";
import * as TrackingService from "../../tracking.service";

export const track = (
    trackingInfo: Omit<ButtonImpressionTrackingInfo, "placement">,
    element: HTMLElement
) => {
    const placement = findClosestContext(element)?.name ?? "";

    const event: AnalyticsEvent<ButtonImpressionTrackingInfo> = {
        event: EventType.ButtonImpression,
        payload: {
            eventData: {
                ...trackingInfo,
                placement
            }
        }
    };

    TrackingService.track(event);
};

export const trackElement = (element: HTMLElement) => {
    const trackingInfo = getJsonPayload(element);

    track(trackingInfo, element);
};
